export const NOTIFICATION_CHANNEL_COLUMN_WIDTH = '3.5rem';
export const NOTIFICATION_GROUP_CONTENT_INLINE_INSET = '0.75rem';

export const getNotificationChannelGridColumns = (channelCount: number, includeContentColumn = true): string => {
    const contentColumn = includeContentColumn ? 'minmax(0, 1fr)' : '';
    const channelColumns = channelCount > 0 ? `repeat(${channelCount}, ${NOTIFICATION_CHANNEL_COLUMN_WIDTH})` : '';

    return [contentColumn, channelColumns].filter(Boolean).join(' ');
};

export const NOTIFICATION_OPTION_GRID_WIDTH = `calc(100% + ${NOTIFICATION_GROUP_CONTENT_INLINE_INSET})`;
